// passing the path into variables

const banner1 ='/assets/centropuerto/Home/Home-Banner-01.webp';


const banner = [banner1];



const centropuertoSlides = {
  banner,
};

export default centropuertoSlides;



// WEBPACK FOOTER //
// ./src/features/themes/functions/getSlides/centropuertoSlides.js